import React, { useState, useEffect } from 'react'
import { Field, Form, Formik } from 'formik'
import * as Yup from 'yup'
import { useHistory, useLocation } from 'react-router-dom'
import { isEmpty } from 'lodash'
import Modal from 'components/Modal'
import TextBox from 'components/TextBox'
import { useDispatch, useSelector } from 'react-redux'
import {
  addServiceType,
  updateServiceType,
} from 'store/ServiceTypes/actions'
import RadioButton from 'components/RadioButton'
import { v4 as uuid } from 'uuid'
import {
  getCurrentMenuForRevenueCenterFromExistingMenus,
  getCurrentRevenueCenter,
} from 'store/RevenueCenters/selector'
import { getNewCurrentServiceType } from 'store/ServiceTypes/selector'
import { DEFAULT_SERVICE_TYPE_NAME } from 'resources'

const AddServiceType = () => {
  const { state: locationState } = useLocation()

  const serviceTypeUuid = locationState?.serviceTypeUuid
  const revenueCenterUuid = locationState?.revenueCenterUuid

  const [showValidationErrors, setShowValidationErrors] =
    useState(false)
  const [serviceTypeOptions, setServiceTypeOptions] = useState()

  const currentRevenueCenter = useSelector((state) =>
    getCurrentRevenueCenter(state, revenueCenterUuid)
  )
  const currentNewServiceType = useSelector((state) =>
    getNewCurrentServiceType(state, serviceTypeUuid)
  )
  const currentExistingMenu = useSelector((state) =>
    getCurrentMenuForRevenueCenterFromExistingMenus(
      state,
      currentRevenueCenter.id,
      serviceTypeUuid
    )
  )

  const dispatch = useDispatch()
  const history = useHistory()

  const existDisplayName =
    !isEmpty(currentExistingMenu?.displayName) &&
    isEmpty(currentNewServiceType?.displayName)
      ? currentExistingMenu?.displayName
      : currentNewServiceType?.displayName

  const existServiceType = !isEmpty(currentExistingMenu?.serviceType)
    ? currentExistingMenu?.serviceType
    : currentNewServiceType?.serviceType

  const initialValues = {
    displayName: existDisplayName,
    serviceType: existServiceType,
  }

  const validationSchema = Yup.object().shape({
    displayName: Yup.string().required('Required'),
    serviceType: Yup.string().required('Required'),
  })

  const disableUpdateButton = (errors) => {
    const disableButton = showValidationErrors && !isEmpty(errors)

    return disableButton
  }

  const onCloseModal = () => {
    history.push({
      state: {
        ...history.location.state,
        serviceTypeUuid: null,
        modalType: null,
      },
    })
  }

  const onClickSaveButton = () => {
    setShowValidationErrors(true)
  }

  const modalTitle =
    serviceTypeUuid === 'new'
      ? 'Add a Service Type'
      : 'Edit a Service Type'

  const onSubmit = (values) => {
    const { displayName, serviceType } = values

    const transformedServiceType =
      serviceType === 'Pickup' ? 'Concessions' : serviceType

    const newServiceType = {
      displayName,
      serviceType: transformedServiceType,
      uuid: uuid(),
      standId: currentRevenueCenter.id,
    }

    const updatedServiceType = {
      ...currentExistingMenu,
      ...currentNewServiceType,
      displayName,
      serviceType: transformedServiceType,
    }

    if (serviceTypeUuid === 'new') {
      dispatch(addServiceType(newServiceType))
    } else {
      dispatch(updateServiceType(updatedServiceType))
    }

    history.push({
      state: {
        ...history.location.state,
        serviceTypeUuid: null,
        modalType: null,
      },
    })
  }

  useEffect(() => {
    setServiceTypeOptions(existServiceType)
  }, [])

  return (
    <Modal
      title={modalTitle}
      onClose={onCloseModal}
      className="-narrow"
    >
      <div className="modal-body">
        <Formik
          enableReinitialize
          initialValues={initialValues}
          onSubmit={onSubmit}
          validationSchema={validationSchema}
        >
          {({ errors, setFieldValue }) => (
            <Form>
              <div className="item-settings">
                <div className="content-wrapper">
                  <Field
                    component={TextBox}
                    label="Display Name"
                    name="displayName"
                    showValidationErrors={showValidationErrors}
                    required={false}
                  />
                </div>
                <section>
                  <h3 className="header-title">Service Type</h3>
                  {DEFAULT_SERVICE_TYPE_NAME.map(({ name }, idx) => (
                    <div
                      className="content-wrapper -flags-wrapper"
                      key={idx}
                    >
                      <Field
                        component={RadioButton}
                        name="serviceType"
                        placeholder={name}
                        type="radio"
                        checked={
                          serviceTypeOptions === 'Concessions' &&
                          name === 'Pickup'
                            ? true
                            : serviceTypeOptions === name
                        }
                        onClick={() => {
                          setServiceTypeOptions(name)
                          setFieldValue('serviceType', name)
                        }}
                        disabled={
                          !isEmpty(currentExistingMenu?.serviceType)
                        }
                        showValidationErrors={showValidationErrors}
                      />
                    </div>
                  ))}
                </section>
                <div className="btn-wrapper">
                  <button
                    className="btn -update"
                    onClick={onClickSaveButton}
                    disabled={disableUpdateButton(errors)}
                    type="submit"
                  >
                    Save
                  </button>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </Modal>
  )
}

export default AddServiceType
